var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "rfp-manager-group-by toolbox flex-hold" },
    [
      _vm.$slots.label
        ? _c("label", { staticClass: "toolbox-label" }, [_vm._t("label")], 2)
        : _vm._e(),
      _c(
        "rb-dropdown",
        {
          staticClass: "toolbox-content",
          attrs: {
            "is-open": _vm.open,
            "backdrop-style": "backdropStyle",
            align: _vm.align,
          },
          on: { close: _vm.toggle },
        },
        [
          _vm._v(" " + _vm._s(_vm.items.length) + " "),
          _c(
            "div",
            {
              staticClass: "rfp-manager-select",
              attrs: { slot: "toggler" },
              on: { click: _vm.toggle },
              slot: "toggler",
            },
            [
              _c("span", [_vm._t("value")], 2),
              _vm.open
                ? _c("i", { staticClass: "material-icons" }, [
                    _vm._v(" arrow_drop_up "),
                  ])
                : _c("i", { staticClass: "material-icons" }, [
                    _vm._v(" arrow_drop_down "),
                  ]),
            ]
          ),
          _c(
            "div",
            { attrs: { slot: "dropdown" }, slot: "dropdown" },
            [
              _vm._l(_vm.items, function (item) {
                return _c(
                  "div",
                  {
                    key: item.id,
                    staticClass: "dropdown-menu-item",
                    class: { selected: item.id === _vm.value.id },
                    on: {
                      click: function ($event) {
                        return _vm.select(item)
                      },
                    },
                  },
                  [
                    item.icon
                      ? _c("i", { staticClass: "material-icons" }, [
                          _vm._v(" " + _vm._s(item.icon) + " "),
                        ])
                      : _vm._e(),
                    _c("span", { domProps: { innerHTML: _vm._s(item.label) } }),
                  ]
                )
              }),
              !_vm.items.length
                ? _c("div", { staticClass: "dropdown-menu-empty" }, [
                    _vm._v(" " + _vm._s(_vm.noItemsMessage) + " "),
                  ])
                : _vm._e(),
            ],
            2
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }